import React, { Component } from 'react';
import striptags from 'striptags';
import htmlentities from 'htmlentities';
import ReactGoogleMapImage from 'react-google-map-image';
import './App.css';

class Result extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxResults: 5
    };

    this.relatedLinks = [];
  }

  findHref(string) {
    if (string === null) {
      return "";
    } else {
      return string.match(/href="([^"]*)/)[1];
    }
  }


  render() {
    const { result } = this.props;

    // Google Map
    const googleMapApiConfig = {
      center: `${result.lat},${result.lng}`,
      size: '300x200',
      zoom: '14',
      key: 'AIzaSyANsr5OIQWk9DsYhRzb4rDbJApswm6h8mU',
      maptype: 'roadmap'
    }

    this.relatedLinks = result.Related.split('</a>", ');

    return (
      <div className="search-result">
        {result.type === 'Contact' && result.lat != '' &&
          <ReactGoogleMapImage
            config={googleMapApiConfig}
            wrapperStyle={{ width: '100%' }}
          />
        }
        {result.type === 'Contact' && result.lat == '' &&
          <img src="/themes/custom/cornellras/image/cornell-search-result-logo.png" className="img-fluid search-logo" />
        }
        {result.type === 'Contact' &&
          <h4 className="search-results-header"><a href={`/node/${striptags(result.Link)}`}>{htmlentities.decode(result.field_first_name)} {htmlentities.decode(result.field_last_name)}</a></h4>
        }
        {result.type != 'Contact' &&
          <h4 className="search-results-header"><a href={`/node/${striptags(result.Link)}`}>{htmlentities.decode(result.Title)}</a></h4>
        }
        {result.type === 'Contact' && result.field_role != '' &&
          <span><strong>{htmlentities.decode(result.field_role)}</strong></span>
        }
        {result.type === 'Contact' && result.fieldfield_email_add_role != '' &&
          <div className="search-email"><a href={"mailto:" + striptags(result.field_email_add)}>{htmlentities.decode(result.field_email_add)}</a></div>
        }
        {result.type === 'Contact' && result.field_secondary_email != '' &&
          <div className="search-email"><a href={"mailto:" + striptags(result.field_secondary_email)}>{htmlentities.decode(result.field_secondary_email)}</a></div>
        }
        {result.type === 'Contact' && result.field_primary_phone != '' &&
          <div className="search-phone"><a href={"tel:" + striptags(result.field_primary_phone)}>{striptags(result.field_primary_phone)}</a></div>
        }
        {result.type === 'Contact' && result.field_secondary_phone != '' &&
          <div className="search-phone"><a href={"tel:" + striptags(result.field_secondary_phone)}>{striptags(result.field_secondary_phone)}</a></div>
        }
        {result.type === 'Contact' && result.field_office_department_unit != '' &&
          <div className="field--name-field-office-department-unit search-result-office">{htmlentities.decode(result.field_office_department_unit)}</div>
        }
        {result.Intro &&
          <p className="search-result-intro">{striptags(htmlentities.decode(result.Intro)).substr(0, 100)}...</p>
        }
        {this.relatedLinks[0].length > 2 &&
          <div className="related-tags-container">
            <p className="related-tags-header">Related: </p>
            {this.relatedLinks.map((link, i) => (
              <a href={this.findHref(link)} key={i}>{striptags(link)}<span>,</span></a>
            ))}
          </div>
        }
      </div>
    );
  }
}

export default Result;



// WEBPACK FOOTER //
// ./src/Result.js